const mixinProps = {
  props: {
    filterOfAssociation: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the association filter to show',
    },
    filterOfBusinesses: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the businesses filter to show',
    },
    filterOfCrops: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the crops filter to show',
    },
    filterOfCropTypes: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the crop types filter to show',
    },
    filterOfZones: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the zones filter to show',
    },
    filterOfSubZones: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the sub zones filter to show',
    },
    filterOfFarms: {
      type: Boolean,
      default: true,
      description: 'Use it whenever you want the farms filter to show',
    },
    filterOfLots: {
      type: Boolean,
      default: true,
      description: 'Use it whenever you want the lots filter to show',
    },
    filterOfRibbons: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the ribbons filter to show',
    },
    filterOfUsers: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the users filter to show',
    },
    filterOfWorkers: {
      type: Boolean,
      default: false,
      description: 'Use it whenever you want the workers filter to show',
    },
    filterOfTimeRange: {
      type: Boolean,
      default: true,
      description: 'Use it whenever you want the time range filter to show',
    },
    onlyFarmsFruits: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the farms filter to show only fruits',
    },
    isDrawerContent: {
      type: Boolean,
      default: false,
      description:
        'Use it when you want that component is show how drawer content',
    },
    isRequiredAssociations: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the associations filter is required',
    },
    isRequiredBusinesses: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the businesses filter is required',
    },
    isRequiredCrops: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the crops filter is required',
    },
    isRequiredCropTypes: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the crop types filter is required',
    },
    isRequiredZones: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the zones filter is required',
    },
    isRequiredSubZones: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the sub zones filter is required',
    },
    isRequiredFarms: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the farms filter is required',
    },
    isRequiredLots: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the lots filter is required',
    },
    isRequiredRibbons: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the ribbons filter is required',
    },
    isRequiredUsers: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the users filter is required',
    },
    isRequiredWorkers: {
      type: Boolean,
      default: false,
      description: 'Use it when you want the workers filter is required',
    },
    classAssociation: {
      type: String,
      default: `col-12 col-sm-6 col-md-5 col-lg-5 col-xl-3`,
    },
    classBusinesses: {
      type: String,
      default: 'col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3',
    },
    classZones: {
      type: String,
      default: 'col-12 col-sm-6 col-md-4 col-xl-3',
    },
    classSubZones: {
      type: String,
      default: 'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2',
    },
    classCropTypes: {
      type: String,
      default: 'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2',
    },
    classCrops: {
      type: String,
      default: 'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2',
    },
    classCalendar: {
      type: String,
      default: 'col-12 col-sm-6 col-md-5 col-xl-3',
    },
    classFarms: {
      type: String,
      default: 'col-12 col-sm-6 col-md-5 col-xl-3',
    },
    classLots: {
      type: String,
      default: 'col-12 col-sm-6 col-lg-5 col-xl-4',
    },
    classRibbons: {
      type: String,
      default: 'col-12 col-sm-6 col-lg-5 col-xl-4',
    },
    classUsers: {
      type: String,
      default: 'col-12 col-sm-6 col-lg-5 col-xl-4',
    },
    classWorkers: {
      type: String,
      default: 'col-12 col-sm-6 col-lg-5 col-xl-4',
    },
    onlyWeekTime: {
      type: Boolean,
      default: false,
    },
    showDivision: {
      type: Boolean,
      default: false,
    },
    showHour: {
      type: Boolean,
      default: false,
    },
    showComparate: {
      type: Number,
      default: 0,
    },
    isMultipleFarms: {
      type: Boolean,
      default: true,
      description: 'Use it when you want the farms select is multiple',
    },
    isMultipleLots: {
      type: Boolean,
      default: true,
      description: 'Use it when you want the lots select is multiple',
    },
  },
};

export default mixinProps;
